export * from './dnn-menu-helper/dnn-inpage-edit';
// tslint:disable-next-line: no-var-requires
const autorun = require('./dnn-workarounds/dnn-08.00.04');